import { Button, Row } from "antd";
import { useMemo } from "react";
import { usePermissions } from "../../../../../../lib/hooks/usePermissions";

type FooterProps = {
  selectedItem: any;
  isFormDisabled: boolean;
  showAddAndNewButton: boolean;
  close: () => void;
  onAddClicked: (value: boolean) => void;
  onRemove: () => void;
};

export const Footer = ({
  selectedItem,
  isFormDisabled,
  showAddAndNewButton,
  close,
  onAddClicked,
  onRemove,
}: FooterProps) => {
  const { hasAccess } = usePermissions();

  const containerClassName: string = useMemo(
    () => `divider px-6 py-6 ${selectedItem ? "justify-space-between" : ""}`,
    [selectedItem],
  );

  const isCloseDisabled: boolean = useMemo(() => {
    if (hasAccess("CustomersBankAccounts", selectedItem ? "Modify" : "Add")) {
      return isFormDisabled;
    }

    return false;
  }, [hasAccess, isFormDisabled, selectedItem]);

  return (
    <Row className={containerClassName}>
      <Row>
        {hasAccess(
          "CustomersBankAccounts",
          selectedItem ? "Modify" : "Add",
        ) && (
          <Button
            shape="round"
            type="primary"
            className="mr-3"
            onClick={() => onAddClicked(false)}
            disabled={isFormDisabled}
            loading={isFormDisabled}
          >
            {selectedItem ? "Save" : "Add"}
          </Button>
        )}
        {showAddAndNewButton &&
          !selectedItem &&
          hasAccess("CustomersBankAccounts", "Add") && (
            <Button
              shape="round"
              className="mr-3"
              disabled={isFormDisabled}
              onClick={() => onAddClicked(true)}
              loading={isFormDisabled}
            >
              Add & New
            </Button>
          )}
        <Button
          shape="round"
          className="mr-3"
          onClick={close}
          disabled={isCloseDisabled}
        >
          Cancel
        </Button>
        {hasAccess("CustomersBankAccounts", "Delete") && selectedItem && (
          <Button type="link" onClick={onRemove} disabled={isFormDisabled}>
            Remove
          </Button>
        )}
      </Row>
    </Row>
  );
};
